import jQuery from 'jquery';
import {
    BestOdds, BetHandler, priceButton, pricesProvider,
} from 'rp-prices-component';
import BetslipInteracter from './shared/price/BetslipInteracter';
import BetInterceptor from './shared/price/BetInterceptor';

function initPrices() {
    const customizeSettings = jQuery.cookie('customizeSettings');
    let showPrices = false;

    try {
        showPrices = JSON.parse(customizeSettings).showPrices;
    } catch (e) {
        console.warn(e);
    }

    /* eslint-disable no-new */
    new BetInterceptor();
    /* eslint-enable no-new */

    priceButton.activate();

    if (showPrices) {
        /* eslint-disable no-new */
        new BestOdds();
        new BetHandler();
        /* eslint-enable no-new */

        const betslipInteracter = new BetslipInteracter();
        betslipInteracter.init()
            .then(betslipFeedName => pricesProvider.init(betslipFeedName));
    } else {
        const storedBookmaker = localStorage.getItem('selectedBookmaker');
        // Janus uses '#V2_BESTODDS' as its BestOdds constant; map it to the
        // rp-prices-component equivalent '#BESTODDS' so Diffusion topics resolve correctly.
        const bookmaker = (!storedBookmaker || storedBookmaker === '#V2_BESTODDS')
            ? '#BESTODDS'
            : storedBookmaker;
        pricesProvider.init(bookmaker);
    }
}

export default initPrices;



// WEBPACK FOOTER //
// ./src/js/initPrices.js